export default class Breakpoint {

	constructor(type, width, callbackTrue, callbackFalse = null) {
		this.type          = type;
		this.width         = width;
		this.callbackTrue  = callbackTrue;
		this.callbackFalse = callbackFalse;
		this.mediaQuery    = `(${this.type}-width: ${this.width}px)`;
		this.matchMedia    = window.matchMedia(this.mediaQuery);

		this.refresh = this.refresh.bind(this);

		this.matchMedia.addListener(this.refresh);
	}

	refresh() {
		if (!this.callbackFalse) {
			this.callbackTrue.call(null, this);
			return;
		}

		if (this.matchMedia.matches) {
			this.callbackTrue.call(null, this);
		} else {
			this.callbackFalse.call(null, this);
		}
	}

}
